import { render, staticRenderFns } from "./YoukeQuntiHuaxiang.vue?vue&type=template&id=c03b55fc&scoped=true&"
import script from "./YoukeQuntiHuaxiang.vue?vue&type=script&lang=js&"
export * from "./YoukeQuntiHuaxiang.vue?vue&type=script&lang=js&"
import style0 from "./YoukeQuntiHuaxiang.vue?vue&type=style&index=0&id=c03b55fc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c03b55fc",
  null
  
)

export default component.exports